const breakpoints = {
  base: '0rem',
  tablet: '53rem', // 848px
  desktop: '80rem', // 1280px
  wideDesktop: '101rem', // 1616px
};

export default breakpoints;
